import "core-js/modules/es.error.cause.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "stock_manager"
};
const _hoisted_2 = {
  class: "base_screen_header"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, null, -1);

const _hoisted_4 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "align-items": "start",
    "gap": "5px"
  }
};
const _hoisted_5 = {
  class: "dialog-footer"
};
const _hoisted_6 = {
  class: "dialog-footer"
};
import DataCollectTable from '@com/table/DataCollectTable.vue';
import { OP_KEY, OPERATIONS, COLUMN_TYPE, operationsHander } from "@com/table/tableOperations";
import { ref, reactive } from 'vue';
import { Search } from '@element-plus/icons-vue';
import useRoute from "@util/router";
import api from "@api/goodsStock";
import $ from "@util/base";
import { $box, $msg } from '@/common/ui/msg';
export default {
  __name: 'GoodsStockManager',

  setup(__props, {
    expose: __expose
  }) {
    const route = useRoute();
    const baseOptions = ref([]);
    const total = ref(0);
    const data = ref([]);
    const base = ref(route.query().base || '');
    const name = ref(route.query().name || '');
    const sku = ref(route.query().sku || '');
    const dialogVisible = ref(false);
    const dialogExportVisible = ref(false);
    const formRef = ref(null);
    route.watchRouter("financestockmanager", () => {
      if ($.isNull(route.query().tab) || route.query().tab == "goods") {
        getData();
      }
    });
    let params = ref({
      name: null,
      page: null,
      size: null
    });

    function pageChange(key, val) {
      params.value[key] = val;
      getData();
    }

    const date = ref(route.query().date || []);

    function searchDate(val) {
      route.replaceQuery("date", val);
    }

    const tableRef = ref(null);

    const submitExportForm = async formEl => {
      // let exportFormData = tableRef.value;
      console.log("formExport" + JSON.stringify(formExport));
      let startDate = new Date(formExport.date[0]);
      let endDate = new Date(formExport.date[1]);
      if (!formEl) return;
      await formEl.validate((valid, fields) => {
        if (valid) {
          let data = tableRef.value.getSelectData();
          let routeQuery = route.query();
          let arr = data.map(item => {
            return item.skuCode;
          });
          console.log("arr" + JSON.stringify(arr));
          api.stockChangeExport({
            changeType: routeQuery.type,
            shopCode: routeQuery.base,
            productName: routeQuery.name,
            skuCodes: arr,
            startTime: startDate,
            endDate: endDate
          }, val => {
            $.download(val.url, "库存变更记录导出");
            dialogExportVisible.value = false;
          });
        }
      });
    };

    function goodsExport() {
      let data = tableRef.value.getSelectData();
      console.log("data" + JSON.stringify(data));

      if ($.isEmpty(data)) {
        $msg.error("请勾选需要导出的产品");
      } else {
        dialogExportVisible.value = true; // let routeQuery = route.query();
        // let arr = data.map(item => {
        //   return item.skuCode
        // })
        // console.log("arr" + JSON.stringify(arr));
      }
    }

    const typeOptions = [{
      label: '增加',
      value: 1
    }, {
      label: '减少',
      value: 2
    }];
    const inventoryFormRef = ref('');
    const inventoryForm = reactive({
      type: null,
      amount: null,
      remark: null
    });
    const formExport = reactive({
      date: []
    });

    const checkAmount = (rule, value, callback) => {
      if (value <= 0) {
        callback(new Error('不能小于0'));
      }

      return true;
    };

    const rules = {};
    const inventoryRules = {
      type: [{
        required: true,
        message: '请选择变更类型',
        trigger: 'change'
      }],
      amount: [{
        required: true,
        message: '请输入变更数量',
        trigger: 'blur'
      }, {
        type: 'number',
        message: '请输入数字'
      }, {
        validator: checkAmount
      }]
    };

    const stockChange = formEl => {
      formEl.validate((valid, fields) => {
        if (valid) {
          if (stockChangeData != null) {
            api.stockChange({
              productCode: stockChangeData.productCode,
              skuCode: stockChangeData.skuCode,
              changeNum: inventoryForm.amount,
              changeFlag: inventoryForm.type,
              remark: inventoryForm.remark
            }, () => {
              $msg.succ("变更成功");
              dialogVisible.value = false;
              formEl.resetFields();
              getData();
            });
          } else {
            $msg.error("请重新选择记录操作");
          }
        }
      });
    };

    const resetForm = formEl => {
      if (!formEl) return;
      formEl.resetFields();
    };

    function goodsOperations(data) {
      return [OPERATIONS.checkInfo];
    }

    const config = {
      showSelection: true,
      showIndex: true,
      operations: {
        label: "操作",
        width: 130,
        operations: goodsOperations
      },
      column: [{
        label: '商品名称',
        prop: 'productName',
        type: COLUMN_TYPE.linkText,
        operationsKey: OPERATIONS.linkText
      }, {
        label: '规格名称',
        prop: 'attrDetail',
        width: 180
      }, {
        label: '规格编码',
        prop: 'skuCode',
        width: 150
      }, // {
      //   label: "成本价（元）",
      //   prop: "costPrice",
      //   type: COLUMN_TYPE.inputPrice,
      //   operationsKey: OPERATIONS.inputPrice,
      //   width: 120,
      // },
      {
        label: '归属基地',
        prop: 'shop',
        width: 150
      }, {
        label: '单位',
        prop: 'sellUnit',
        width: 100
      }, {
        label: '当前库存',
        prop: 'stockNum',
        width: 140
      } // , {
      //   label: '可用库存',
      //   prop: 'lockNum',
      //   width: 140,
      // }
      ]
    };
    var stockChangeData = null;
    const opHander = operationsHander();
    opHander.install(OP_KEY.inventory, data => {
      stockChangeData = data;
      dialogVisible.value = true;
    });
    opHander.install(OP_KEY.inputPrice, data => {
      api.costUpdate(data.value, data.data.skuCode, () => {
        $msg.succ("修改成功");
      });
    });
    opHander.install(OP_KEY.linkText, data => {
      route.push({
        name: 'goodsstockrecode',
        query: {
          sku: data.skuCode
        }
      });
    });
    opHander.install(OP_KEY.checkInfo, data => {
      route.push({
        name: 'goodsstockrecode',
        query: {
          sku: data.skuCode
        }
      });
    });

    function searchBase(val) {
      route.replaceQuery('base', val);
    }

    function searchName(val) {
      route.replaceQuery('name', val);
    }

    function searchSKU(val) {
      route.replaceQuery('sku', val);
    }

    getConfig();

    function getConfig() {
      api.base(val => {
        baseOptions.value = val;
      });
    }

    getData();

    function getData() {
      let routeQuery = route.query();
      api.skuStock({
        skuCode: routeQuery.sku,
        shopCode: routeQuery.base,
        productName: routeQuery.name,
        date: routeQuery.date,
        page: routeQuery.p,
        size: routeQuery.s
      }, val => {
        data.value = val.itemList;
        total.value = val.total;
      });
    }

    function getExport() {
      let routeQuery = route.query();
      api.stockExport({
        skuCode: routeQuery.sku,
        shopCode: routeQuery.base,
        date: routeQuery.date,
        productName: routeQuery.name
      }, val => {
        $.download(val.url, "库存列表导出");
      });
    }

    function getSelection() {
      let data = tableRef.value.getSelectData();
      data = data.map(item => {
        return item.code;
      });
      return data;
    }

    function getSelectData() {
      let data = tableRef.value.getSelectData();
      return data;
    }

    function clearSelection() {
      tableRef.value.clearSelection();
    }

    function empty() {
      total.value = 0;
      data.value = [];
    }

    __expose({
      getSelection,
      getSelectData,
      empty,
      clearSelection
    });

    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _directive_auth = _resolveDirective("auth");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_main, {
        class: "base_main_content"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_form, {
          inline: true,
          class: "base_search_form",
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: base.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => base.value = $event),
              onChange: searchBase,
              placeholder: "请选择基地",
              clearable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseOptions.value, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: name.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => name.value = $event),
              "onKeyup[native]": searchName,
              onChange: searchName,
              placeholder: "商品名称",
              "suffix-icon": _unref(Search),
              clearable: ""
            }, null, 8, ["modelValue", "suffix-icon"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: sku.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => sku.value = $event),
              "onKeyup[native]": searchSKU,
              onChange: searchSKU,
              placeholder: "SKU编码",
              "suffix-icon": _unref(Search),
              clearable: ""
            }, null, 8, ["modelValue", "suffix-icon"])]),
            _: 1
          })]),
          _: 1
        })]), _createElementVNode("div", _hoisted_4, [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          text: "",
          onClick: goodsExport
        }, {
          default: _withCtx(() => [_createTextVNode("批量导出")]),
          _: 1
        })), [[_directive_auth, _ctx.getCurCode('EXPORT')]])]), _createVNode(DataCollectTable, {
          ref_key: "tableRef",
          ref: tableRef,
          data: data.value,
          total: total.value,
          config: config,
          onOperationsHander: _unref(opHander).receive,
          isRoute: false,
          isRadio: false,
          onPageChange: pageChange
        }, null, 8, ["data", "total", "onOperationsHander"])]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => dialogVisible.value = $event),
        title: "库存变化",
        width: "35%",
        top: "30vh",
        class: "base_dialog",
        onOpen: _cache[10] || (_cache[10] = $event => resetForm(inventoryFormRef.value))
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_5, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[7] || (_cache[7] = $event => stockChange(inventoryFormRef.value))
        }, {
          default: _withCtx(() => [_createTextVNode("保存")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: _cache[8] || (_cache[8] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "inventoryFormRef",
          ref: inventoryFormRef,
          model: inventoryForm,
          rules: inventoryRules,
          "label-width": "80px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "变更类型",
            prop: "type"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: inventoryForm.type,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => inventoryForm.type = $event)
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(typeOptions, (item, index) => {
                return _createVNode(_component_el_radio, {
                  key: index,
                  label: item.value
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                  _: 2
                }, 1032, ["label"]);
              }), 64))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "变更数量",
            prop: "amount"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: inventoryForm.amount,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => inventoryForm.amount = $event),
              modelModifiers: {
                number: true
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "备注"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: inventoryForm.remark,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => inventoryForm.remark = $event),
              type: "textarea",
              clearable: "",
              resize: "none"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: dialogExportVisible.value,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => dialogExportVisible.value = $event),
        title: "批量导出商品库存",
        width: "35%",
        top: "35vh",
        class: "base_dialog"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_6, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[12] || (_cache[12] = $event => submitExportForm(formRef.value))
        }, {
          default: _withCtx(() => [_createTextVNode("导出")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: _cache[13] || (_cache[13] = $event => dialogExportVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: formExport,
          ref_key: "formRef",
          ref: formRef
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "变更时间范围"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: formExport.date,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => formExport.date = $event),
              type: "daterange",
              "range-separator": "~",
              "start-placeholder": "开始时间",
              "end-placeholder": "结束时间",
              "value-format": "YYYY-MM-DD"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};